import CircularLoader from "@/components/loading/LoadingComponent";
import { gql, useQuery } from "@apollo/client";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const STREAM_TEAM_CHECK_QUERY = gql`
    query StreamTeamCheck {
        myAccount {
            isStreamTeam
        }
    }
`;

interface GuardProps {
    children: React.ReactNode;
}

const StreamTeamGuard = ({ children }: GuardProps) => {
    const navigate = useNavigate();
    const { data, loading } = useQuery(STREAM_TEAM_CHECK_QUERY);

    useEffect(() => {
        if (!loading && data && !data.myAccount?.isStreamTeam) {
            navigate("/dashboard/my-account");
        }
    }, [data, loading, navigate]);

    if (loading) {
        return <CircularLoader />;
    }

    return data?.myAccount?.isStreamTeam ? <>{children}</> : null;
};

export default StreamTeamGuard;
